import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import '../index.css';
import PayTab from './PayTab';
import DetailsTab from './DetailsTab';
import axios from 'axios';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const BarModalTwo = ({ bar, isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('pay');
  const [passes, setPasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setActiveTab('pay');
      fetchPasses();
    }
  }, [isOpen]);

  const fetchPasses = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_AWS_URL}/${process.env.REACT_APP_STAGE}/getPasses`, { bar_id: bar.bar_id });
      setPasses(response.data.passes);
    } catch (error) {
      console.error('Error fetching passes:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !bar) return null;

  const modalContent = (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="bar-modal-header">
          <img src={bar.cover_photo_url || '/Default Cover Photo.webp'} alt="Cover Photo" className="cover-photo" />
          <FaTimes className="bar-modal-close-icon" onClick={onClose} />
        </div>
        <div className="modal-content">
        <div className="tab-toggle-container">
            <button
                className={`tab-button ${activeTab === 'pay' ? 'active-tab-button' : ''}`}
                onClick={() => setActiveTab('pay')}>
                Hop Passes
            </button>
            <button
                className={`tab-button ${activeTab === 'details' ? 'active-tab-button' : ''}`}
                onClick={() => setActiveTab('details')}>
                Details
            </button>
        </div>
          {activeTab === 'pay' ? (
            loading ? (
              <div className="loading-container">Loading...</div>
            ) : (
              <Elements stripe={stripePromise}>
                <PayTab bar={bar} passes={passes} />
              </Elements>
            )
          ) : (
            <DetailsTab bar={bar} />
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default BarModalTwo;